import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.revealCurrentDate()
    this.observer = new ResizeObserver(() => {
      const overflowing = this.element.scrollWidth > this.element.clientWidth
      if (overflowing && !this.wasOverflowing) {
        this.revealCurrentDate()
      }
      this.wasOverflowing = overflowing
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
  }

  revealCurrentDate() {
    const selected = this.element.querySelector("[aria-current='date']")
    if (selected) {
      const left = selected.getBoundingClientRect().left - this.element.getBoundingClientRect().left
      this.element.scrollLeft += left - (this.element.clientWidth - selected.getBoundingClientRect().width) / 2
    } else {
      this.element.scrollLeft = this.element.scrollWidth - this.element.clientWidth
    }
  }
}
